import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { StyledSpinnerWithLabel } from '@bingads-webui-campaign-react/shell-ui-common';
import CampaignTreeNodeWithTooltip from './campaign-tree-node-with-tooltip';

const CampaignTreeNode = ({
  classes, node,
}) => {
  if (node.isPlaceholderNode) {
    if (node.isLoadingData) {
      return (
        <div className={classNames([classes.baseMenuItem,
        (node.entityType === 'Campaign')
          ? classes.rootNodeSpinnerContainer
          : classes.leafNodeSpinnerContainer])}
        >
          <StyledSpinnerWithLabel label={node.name} />
        </div>
      );
    }

    const rootPlaceholderNodeTextContainerClassName = classNames([
      'campaign-tree-node-place-holder',
      classes.textContainer,
      classes.placeholderTextContainer,
    ]);
    const leafPlaceholderNodeTextContainerClassName = classNames([
      'adgroup-tree-node-place-holder',
      classes.textContainer,
      classes.leafNodeTextContainer,
    ]);

    return (
      <div className={classes.baseMenuItem}>
        {
          <span className={
            (node.entityType === 'Campaign')
              ? rootPlaceholderNodeTextContainerClassName
              : leafPlaceholderNodeTextContainerClassName
          }
          >
            {node.name}
          </span>
        }
      </div>
    );
  }

  return (
    <CampaignTreeNodeWithTooltip
      classes={classes}
      node={node}
    />
  );
};

CampaignTreeNode.propTypes = {
  classes: PropTypes.shape({
    baseMenuItem: PropTypes.string.isRequired,
    textContainer: PropTypes.string.isRequired,
    placeholderTextContainer: PropTypes.string.isRequired,
    iconContainer: PropTypes.string.isRequired,
    statusIconContainer: PropTypes.string.isRequired,
    pausedTextContainer: PropTypes.string.isRequired,
    activeStatusIcon: PropTypes.string.isRequired,
    pausedStatusIcon: PropTypes.string.isRequired,
    rootNodeSpinnerContainer: PropTypes.string.isRequired,
    leafNodeSpinnerContainer: PropTypes.string.isRequired,
    hiddenTooltip: PropTypes.string.isRequired,
  }).isRequired,
  node: PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
    name: PropTypes.string.isRequired,
    entityType: PropTypes.string.isRequired,
    status: PropTypes.string,
    isSelected: PropTypes.bool,
    isPlaceholderNode: PropTypes.bool,
    isLoadingData: PropTypes.bool,
  }).isRequired,
};

export function CampaignTreeNodeChildRenderer(classes) {
  return node => (
    <CampaignTreeNode
      classes={classes}
      node={node}
    />
  );
}
